<template id="QrCodes">
    <v-ons-page id="QrCodesPage">

      <v-card class="Card_Contain d-flex align-center flex-column" style="margin-bottom: 75px;">
        <div class="Card_Titulo">
          <h1>QR Codes</h1>
        </div>

        <v-row>
          <h3 class="Titulo">Adicione o número de mesas (QR codes) que desejar,<br> 
            coloque um nome para indentificar e imprima
          </h3>
        </v-row>

        <v-row class="d-flex justify-center" style="width: 50vw; position: relative;">
          <h3 class="Sub_Titulo">Sua lista de mesas:</h3>
          <v-divider style="width: 50vw; position: absolute; bottom: 0;"></v-divider>
        </v-row>
        
        <v-list class="d-flex flex-column align-center" style="width: 50vw;">
          <v-row v-for="(m,k) in arrMesas" v-bind:key="k" class="align-center" style="position: relative; width: 50vw; margin-top: 12px;">
            <v-col>
              <v-ons-input type="text" class="inputMesa" placeholder="Nome da mesa" v-model="m.dsNomeMesa" :disabled="(m.idMesa != editarMesa && stage == 'editar') || (stage != 'editar')" /> 
            </v-col>
            
            <v-col v-show="(m.idMesa == editarMesa && stage == 'editar')">
                <v-ons-button class="btnMesa" @click="salvarMesa(k)">
                  <img src="../assets/img/icoSalvar.png" /><br>  
                  SALVAR
                </v-ons-button>
            </v-col>

            <v-col class="" v-show="(m.idMesa != editarMesa || stage != 'editar')" style=" padding-top: 0;">
              <v-ons-button class="btnMesa" @click="editarMesa = m.idMesa; stage = 'editar'" >
                <img src="../assets/img/btnEditar.png" /><br>
                Editar
              </v-ons-button>
              <v-ons-button @click="openQrCode(m.idMesa)" class="btnMesa">
                <img src="../assets/img/btnImprimir.png" /><br>
                Imprimir
              </v-ons-button>
              <v-ons-button @click="indexMesa = k, idMesaDel= m.idMesa; dialogDel = true;" class="btnMesa">
                <img src="../assets/img/icoExcluir.png" /><br>
                Excluir
              </v-ons-button>
            </v-col>
            <v-divider style="width: 50vw; position: absolute; bottom:0;"></v-divider>
          </v-row>
        </v-list>

        <v-row class="d-flex justify-center" style="width: 50vw; position: relative; margin: 10px 0">
          <div class="title" style="padding-top:0; margin-bottom: 10px " @click="dialog= true; editarMesa=0; novaMesa.dsNomeMesa = ''; ">
            <v-icon
              medium
              color="#212226"
            >
              mdi-plus
            </v-icon>
            <p style=" font-size:0.9rem !important; color:#212226; text-transform: none; margin: 0;">Adicionar novo QRCode</p>
          </div>
          <v-divider style="width: 50vw; position: absolute; bottom:0;"></v-divider>
        </v-row>
        
        <v-row class="d-flex justify-center" style="margin: 30px 0;">
          <v-button @click="printQrCodes()" class="botao" style="margin: 0 !important;">Imprimir Tudo</v-button>
        </v-row>
      </v-card>

      <h3 class="copy">Copyright © 2020. Todos os direitos reservados a Cyma Digital. <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a></h3>
      
      <v-dialog v-model="dialog" max-width="500" transition="dialog-bottom-transition">
        <v-list class=" py-0">
          <v-toolbar dark >
            <v-card-title class="headline">
              Adicionar novo QRCode
            </v-card-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialog = false;">
                  <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-toolbar>
          <v-list-item>
            <v-list-item-content >
              <v-text-field
                type="text"
                label="Nova Mesa"
                require
                v-model="novaMesa.dsNomeMesa"
              ></v-text-field>
              <div class="content">
                <v-ons-button class="botao" @click="adicionarQrCode()">SALVAR</v-ons-button>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-dialog>

      <v-dialog
      v-model="dialogDel"
      persistent
      max-width="500" 
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="headline">
          Remover mesa
        </v-card-title>
        
        <v-card-text style="text-transform: none; font-size: 1rem; margin-top: 10px">Você tem certeza que deseja remover  {{arrMesas[indexMesa] ? arrMesas[indexMesa].dsNomeMesa : ""}} ??</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="removerMesa(idMesaDel, indexMesa)"
          >
            Sim
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="dialogDel = false; indexMesa = 0; idMesaDel = 0;"
          >
            Não
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-ons-page>
</template>
<style scoped>
#QrCodesPage {
  margin-left: 256px;
}
.headline {
  font-size: 1.2rem !important;
  text-transform: none;
}
.Titulo {
  color: #212226;
  margin-top: 90px;
  text-transform: none;
}
.Sub_Titulo {
    color: #212226 !important;
    text-transform: none;
    font-size: 1.1rem;
    margin: 25px 0;
}
.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}
.copy_pos {
  position: absolute;
  bottom: 5px;
  left: calc(50% - 256px);
}
ons-input { 
  margin:0;
  
}
ons-input[disabled] { 
  opacity:1;
  text-align:center;
}
ons-card { 
  width:131px;  
  text-align: center;
  height:160px;
  padding:0px;
  margin-left:15px;
}
ons-card .title { 
  width:130px;
  height:89px;
  font-size:1rem;  
  padding-top:20px;
  font-weight:bold;
  margin-bottom:0px;
}
.btnMesa img { 
  height:15px;
  margin-bottom:-15px;
}
.btnMesa { 
  background:none;
  border:0px;
  box-shadow:none;
  color:#000;
  padding: 0px;
  height: 50px;
  margin: 0 8px;
  line-height:30px;
  text-transform: none; font-size: 0.7rem;
}

h4 {
  font-size:15px;
  color:#eac800;
  text-align: center;
  margin-top: 5px!important;
  margin-left: -440px!important;
  margin-right: 55px;
  padding: 0px 30px!important;
}
h5 {
  font-size:15px;
  color:#eac800;
  text-align: center;
  margin-top: -170px!important;
  margin-left: 575px!important;
  margin-right: 55px!important;
  padding: 20px 0px!important;
}
.content {
  padding: 0;
}
</style>
<script>
export default {
  name: 'QrCodes',
  key: 'QrCodes',
  data() { 
    return {
      stage:"default",
      editarMesa: 0,
      novaMesa: {idEstabelecimento: undefined, dsNomeMesa:""},
      arrMesas: [],
      dialog:false,
      loadingBtn:false,
      dialogDel: false,
      indexMesa: 0, 
      idMesaDel: 0,
    }
  },
  created() {
    var e = JSON.parse(localStorage.getItem("e"))
    this.novaMesa.idEstabelecimento = e.idEstabelecimento
    
    if (e.arrMesas.length > 0) { 
      this.arrMesas = e.arrMesas
    }
      
  },
  methods: {
    saveMesas() { 
      var e = JSON.parse(localStorage.getItem("e"))
      e.arrMesas = this.arrMesas;
      localStorage.setItem("e",JSON.stringify(e))
    },
    adicionarQrCode() { 
      if (this.novaMesa.dsNomeMesa != "") { 
        fetch(this.$menu_uri +'/mesa',
            { method: "OPTIONS",
            headers:  { "Content-Type": "application/json" },
            body: JSON.stringify(this.novaMesa)})
        .then(response => response.json())
        .then(data => {
          if (data.idMesa) {
            
            this.novaMesa.idMesa = data.idMesa; 
            var mesa = Object.assign({},this.novaMesa)
            this.arrMesas.push(mesa) 
            this.saveMesas()
            this.stage = "default"
            this.novaMesa.dsNomeMesa = ""; 
            this.novaMesa.idMesa = undefined; 
            this.dialog = false;
          }
        })
        .then(error => {
          window.console.log(error)
          // this.$ons.notification.toast("Ocorreu um erro, tente novamente! ", { timeout: 1000, animation: 'ascend' });
        })
      }
      else { 
        this.$ons.notification.toast("Por favor insira um nome para a mesa! ", { timeout: 1000, animation: 'ascend' });
      }
    },
    openQrCode(idMesa) { 
      window.open(this.$menu_uri +'/gen-qr-print-mesa/'+ idMesa);
    },
    abrirLink(id) {
      window.open(this.$menu_uri +'/gen-qr-print-mesa/'+ id);
    },
    printQrCodes() { 
      var e = JSON.parse(localStorage.getItem("e"))
      window.open(this.$menu_uri +'/gen-qr-print/'+ btoa(e.idEstabelecimento.toString()));
    },
    removerMesa(idMesa, index) { 
      fetch(this.$menu_uri +'/rem-mesa',
            { method: "OPTIONS", headers:  { "Content-Type": "application/json" },
            body: JSON.stringify({idMesa: idMesa})})
        .then(response => response.json())
        .then(data => { 
          if (data === 1) {
            this.arrMesas.splice(index, 1);
            this.saveMesas()
            this.indexMesa= 0
            this.idMesa= 0
            this.dialogDel = false
          }
          else { 
            this.$ons.notification.toast("Ocorreu um erro ao remover a mesa! ", { timeout: 1000, animation: 'ascend' });     
          }
        })
        .then(error => { window.console.log(error) })
    },
    salvarMesa(index) { 
      fetch(this.$menu_uri +"/salvar-mesa", {method:"OPTIONS", headers:{"Content-Type":"application/json"}, body: JSON.stringify(this.arrMesas[index])})
      .then(response => response.json())
      .then (data => { 
        if((data === 1) || (data === 0)) { 
          this.saveMesas()
          this.stage = "default";
          this.editarMesa = 0;
          this.$ons.notification.toast("Mesa salva com sucesso!", {timeout:1000, animation:"ascend"})
        }
        else { 
          this.$ons.notification.toast("Ocorreu um erro ao salvar a mesa!", {timeout:1000, animation:"ascend"})
        }
      })
      .then(error => { 
        if (error != undefined) { 
          this.$ons.notification.toast("Ocorreu um erro ao salvar a mesa!", {timeout:1000, animation:"ascend"})
        }
      })
    }
  },
  mounted() { 

  }
}
</script>